import React, { useState } from 'react';
import PageWrapper from '../../layout/PageWrapper/PageWrapper';
import Page from '../../layout/Page/Page';
import Card, {
    CardHeader,
    CardBody,
    CardFooter,
} from '../../components/bootstrap/Card';
import Accordion, { AccordionItem } from '../../components/bootstrap/Accordion';
import Button from '../../components/bootstrap/Button';
import Modal, {
    ModalBody,
    ModalHeader,
    ModalTitle,
} from '../../components/bootstrap/Modal';
import AnalyticsCount from './AnalyticsCount';

const PostHistory = () => {
    const [postMetricsModal, setPostMetricsModal] = useState(false);
    return (
        <PageWrapper title='Post History'>
            <Page container='fluid'>
                <div className='row'>
                    {/* FACEBOOK EXAMPLE */}
                    <div className='col-xl-3 col-sm-12'>
                        <Card stretch className='history-card'>
                            <CardHeader>
                                <Accordion
                                    id='account-selection'
                                    className='account-selection-card-history'>
                                    <AccordionItem
                                        id='account-selection'
                                        title='Accounts Posted on'>
                                        <div
                                            className='platform-card-modal'
                                            style={{
                                                borderTop: '5px solid #217BEE',
                                            }}>
                                            <div className='platform-name-modal'>
                                                <div className='account-left'>
                                                    <div className='user-profile'>
                                                        <h5>DS</h5>
                                                    </div>
                                                    <div
                                                        className='account-details'
                                                        style={{
                                                            textAlign: 'left',
                                                        }}>
                                                        <p className='account-name'>
                                                            <img
                                                                src={require('../../assets/facebook.png')}
                                                                width='15'
                                                                style={{
                                                                    marginRight:
                                                                        '5px',
                                                                }}
                                                                alt='Facebook'
                                                            />
                                                            Test
                                                        </p>
                                                        <p className='account-type'>
                                                            Facebook Page
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </AccordionItem>
                                </Accordion>
                            </CardHeader>
                            <CardBody>
                                <div className='account-body'>
                                    <p
                                        className='desc-text'
                                        style={{ marginBottom: '0px' }}>
                                        Preview approximates how your content
                                        will display when published. Tests and
                                        updates by social networks may affect
                                        the final appearance. Report a
                                        difference you notice.
                                    </p>
                                </div>
                                <div
                                    className='account-img-history'
                                    style={{ marginTop: '10px' }}>
                                    <img
                                        src={require('../../assets/post-img.png')}
                                        alt='Post'
                                    />
                                </div>
                            </CardBody>
                            <CardFooter>
                                <div
                                    className='d-flex'
                                    style={{ justifyContent: 'space-between' }}>
                                    <p className='footer-info'>
                                        <strong>Date: </strong>2022-07-25 |
                                        Monday
                                    </p>
                                    <p className='footer-info'>
                                        <strong>Time: </strong>10:24:05 AM
                                    </p>
                                </div>
                                <div className='analytics-link'>
                                    <Button
                                        color='primary'
                                        onClick={() =>
                                            setPostMetricsModal(
                                                !postMetricsModal,
                                            )
                                        }
                                        isLink>
                                        View Post Metrics
                                    </Button>
                                    <Modal
                                        id='post-metrics-modal'
                                        isCentered={true}
                                        isOpen={postMetricsModal}
                                        size='lg'
                                        setIsOpen={() =>
                                            setPostMetricsModal(
                                                !postMetricsModal,
                                            )
                                        }
                                        titleId='post-metrics-title'>
                                        <ModalHeader className='post-metrics-header'>
                                            <ModalTitle
                                                className='post-metrics'
                                                id='post-metrics'>
                                                Post Metrics
                                            </ModalTitle>
                                            <Button
                                                color='primary'
                                                isOutline
                                                onClick={() =>
                                                    setPostMetricsModal(
                                                        !postMetricsModal,
                                                    )
                                                }>
                                                Close
                                            </Button>
                                        </ModalHeader>
                                        <ModalBody className='post-metrics-body'>
                                            <h5>
                                                Engagement, Impressions and
                                                Reach
                                            </h5>
                                            <p>
                                                View the engagement, reach, and
                                                impressions on your post in a
                                                simple and meaningful way.
                                            </p>
                                            <div className='mt-4'>
                                                <AnalyticsCount />
                                            </div>
                                        </ModalBody>
                                    </Modal>
                                </div>
                            </CardFooter>
                        </Card>
                    </div>
                    {/* LINKEDIN EXAMPLE */}
                    <div className='col-xl-3 col-sm-12'>
                        <Card stretch className='history-card'>
                            <CardHeader>
                                <Accordion
                                    id='account-selection'
                                    className='account-selection-card-history'>
                                    <AccordionItem
                                        id='account-selection'
                                        title='Accounts Posted on'>
                                        <div
                                            className='platform-card-modal'
                                            style={{
                                                borderTop: '5px solid #0A66C2',
                                            }}>
                                            <div className='platform-name-modal'>
                                                <div className='account-left'>
                                                    <div className='user-profile'>
                                                        <h5>DS</h5>
                                                    </div>
                                                    <div
                                                        className='account-details'
                                                        style={{
                                                            textAlign: 'left',
                                                        }}>
                                                        <p className='account-name'>
                                                            <img
                                                                src={require('../../assets/linkedin.png')}
                                                                width='15'
                                                                style={{
                                                                    marginRight:
                                                                        '5px',
                                                                }}
                                                                alt='Linkedin'
                                                            />
                                                            Test
                                                        </p>
                                                        <p className='account-type'>
                                                            Linkedin Page
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </AccordionItem>
                                </Accordion>
                            </CardHeader>
                            <CardBody>
                                <div className='account-body'>
                                    <p
                                        className='desc-text'
                                        style={{ marginBottom: '0px' }}>
                                        Preview approximates how your content
                                        will display when published. Tests and
                                        updates by social networks may affect
                                        the final appearance. Report a
                                        difference you notice.
                                    </p>
                                </div>
                                <div
                                    className='account-img-history'
                                    style={{ marginTop: '10px' }}>
                                    <img
                                        src={require('../../assets/post-img.png')}
                                        alt='Post'
                                    />
                                </div>
                            </CardBody>
                            <CardFooter>
                                <div
                                    className='d-flex'
                                    style={{ justifyContent: 'space-between' }}>
                                    <p className='footer-info'>
                                        <strong>Date: </strong>2022-07-25 |
                                        Monday
                                    </p>
                                    <p className='footer-info'>
                                        <strong>Time: </strong>10:24:05 AM
                                    </p>
                                </div>
                                <div className='analytics-link'>
                                    <Button
                                        color='primary'
                                        onClick={() =>
                                            setPostMetricsModal(
                                                !postMetricsModal,
                                            )
                                        }
                                        isLink>
                                        View Post Metrics
                                    </Button>
                                    <Modal
                                        id='post-metrics-modal'
                                        isCentered={true}
                                        isOpen={postMetricsModal}
                                        size='lg'
                                        setIsOpen={() =>
                                            setPostMetricsModal(
                                                !postMetricsModal,
                                            )
                                        }
                                        titleId='post-metrics-title'>
                                        <ModalHeader className='post-metrics-header'>
                                            <ModalTitle
                                                className='post-metrics'
                                                id='post-metrics'>
                                                Post Metrics
                                            </ModalTitle>
                                            <Button
                                                color='primary'
                                                isOutline
                                                onClick={() =>
                                                    setPostMetricsModal(
                                                        !postMetricsModal,
                                                    )
                                                }>
                                                Close
                                            </Button>
                                        </ModalHeader>
                                        <ModalBody className='post-metrics-body'>
                                            <h5>
                                                Engagement, Impressions and
                                                Reach
                                            </h5>
                                            <p>
                                                View the engagement, reach, and
                                                impressions on your post in a
                                                simple and meaningful way.
                                            </p>
                                            <div className='mt-4'>
                                                <AnalyticsCount />
                                            </div>
                                        </ModalBody>
                                    </Modal>
                                </div>
                            </CardFooter>
                        </Card>
                    </div>
                    {/* INSTAGRAM EXAMPLE */}
                    <div className='col-xl-3 col-sm-12'>
                        <Card stretch className='history-card'>
                            <CardHeader>
                                <Accordion
                                    id='account-selection'
                                    className='account-selection-card-history'>
                                    <AccordionItem
                                        id='account-selection'
                                        title='Accounts Posted on'>
                                        <div
                                            className='platform-card-modal'
                                            style={{
                                                borderTop: '5px solid #E4405F',
                                            }}>
                                            <div className='platform-name-modal'>
                                                <div className='account-left'>
                                                    <div className='user-profile'>
                                                        <h5>DS</h5>
                                                    </div>
                                                    <div
                                                        className='account-details'
                                                        style={{
                                                            textAlign: 'left',
                                                        }}>
                                                        <p className='account-name'>
                                                            <img
                                                                src={require('../../assets/instagram.png')}
                                                                width='15'
                                                                style={{
                                                                    marginRight:
                                                                        '5px',
                                                                }}
                                                                alt='Instagram'
                                                            />
                                                            Test
                                                        </p>
                                                        <p className='account-type'>
                                                            Instagram Page
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </AccordionItem>
                                </Accordion>
                            </CardHeader>
                            <CardBody>
                                <div className='account-body'>
                                    <p
                                        className='desc-text'
                                        style={{ marginBottom: '0px' }}>
                                        Preview approximates how your content
                                        will display when published. Tests and
                                        updates by social networks may affect
                                        the final appearance. Report a
                                        difference you notice.
                                    </p>
                                </div>
                                <div
                                    className='account-img-history'
                                    style={{ marginTop: '10px' }}>
                                    <img
                                        src={require('../../assets/post-img.png')}
                                        alt='Post'
                                    />
                                </div>
                            </CardBody>
                            <CardFooter>
                                <div
                                    className='d-flex'
                                    style={{ justifyContent: 'space-between' }}>
                                    <p className='footer-info'>
                                        <strong>Date: </strong>2022-07-25 |
                                        Monday
                                    </p>
                                    <p className='footer-info'>
                                        <strong>Time: </strong>10:24:05 AM
                                    </p>
                                </div>
                                <div className='analytics-link'>
                                    <Button
                                        color='primary'
                                        onClick={() =>
                                            setPostMetricsModal(
                                                !postMetricsModal,
                                            )
                                        }
                                        isLink>
                                        View Post Metrics
                                    </Button>
                                    <Modal
                                        id='post-metrics-modal'
                                        isCentered={true}
                                        isOpen={postMetricsModal}
                                        size='lg'
                                        setIsOpen={() =>
                                            setPostMetricsModal(
                                                !postMetricsModal,
                                            )
                                        }
                                        titleId='post-metrics-title'>
                                        <ModalHeader className='post-metrics-header'>
                                            <ModalTitle
                                                className='post-metrics'
                                                id='post-metrics'>
                                                Post Metrics
                                            </ModalTitle>
                                            <Button
                                                color='primary'
                                                isOutline
                                                onClick={() =>
                                                    setPostMetricsModal(
                                                        !postMetricsModal,
                                                    )
                                                }>
                                                Close
                                            </Button>
                                        </ModalHeader>
                                        <ModalBody className='post-metrics-body'>
                                            <h5>
                                                Engagement, Impressions and
                                                Reach
                                            </h5>
                                            <p>
                                                View the engagement, reach, and
                                                impressions on your post in a
                                                simple and meaningful way.
                                            </p>
                                            <div className='mt-4'>
                                                <AnalyticsCount />
                                            </div>
                                        </ModalBody>
                                    </Modal>
                                </div>
                            </CardFooter>
                        </Card>
                    </div>
                    {/* TWITTER EXAMPLE */}
                    <div className='col-xl-3 col-sm-12'>
                        <Card stretch className='history-card'>
                            <CardHeader>
                                <Accordion
                                    id='account-selection'
                                    className='account-selection-card-history'>
                                    <AccordionItem
                                        id='account-selection'
                                        title='Accounts Posted on'>
                                        <div
                                            className='platform-card-modal'
                                            style={{
                                                borderTop: '5px solid #1DA1F2',
                                            }}>
                                            <div className='platform-name-modal'>
                                                <div className='account-left'>
                                                    <div className='user-profile'>
                                                        <h5>DS</h5>
                                                    </div>
                                                    <div
                                                        className='account-details'
                                                        style={{
                                                            textAlign: 'left',
                                                        }}>
                                                        <p className='account-name'>
                                                            <img
                                                                src={require('../../assets/twitter.png')}
                                                                width='15'
                                                                style={{
                                                                    marginRight:
                                                                        '5px',
                                                                }}
                                                                alt='Twitter'
                                                            />
                                                            Test
                                                        </p>
                                                        <p className='account-type'>
                                                            Twitter Page
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </AccordionItem>
                                </Accordion>
                            </CardHeader>
                            <CardBody>
                                <div className='account-body'>
                                    <p
                                        className='desc-text'
                                        style={{ marginBottom: '0px' }}>
                                        Preview approximates how your content
                                        will display when published. Tests and
                                        updates by social networks may affect
                                        the final appearance. Report a
                                        difference you notice.
                                    </p>
                                </div>
                                <div
                                    className='account-img-history'
                                    style={{ marginTop: '10px' }}>
                                    <img
                                        src={require('../../assets/post-img.png')}
                                        alt='Post'
                                    />
                                </div>
                            </CardBody>
                            <CardFooter>
                                <div
                                    className='d-flex'
                                    style={{ justifyContent: 'space-between' }}>
                                    <p className='footer-info'>
                                        <strong>Date: </strong>2022-07-25 |
                                        Monday
                                    </p>
                                    <p className='footer-info'>
                                        <strong>Time: </strong>10:24:05 AM
                                    </p>
                                </div>
                                <div className='analytics-link'>
                                    <Button
                                        color='primary'
                                        onClick={() =>
                                            setPostMetricsModal(
                                                !postMetricsModal,
                                            )
                                        }
                                        isLink>
                                        View Post Metrics
                                    </Button>
                                    <Modal
                                        id='post-metrics-modal'
                                        isCentered={true}
                                        isOpen={postMetricsModal}
                                        size='lg'
                                        setIsOpen={() =>
                                            setPostMetricsModal(
                                                !postMetricsModal,
                                            )
                                        }
                                        titleId='post-metrics-title'>
                                        <ModalHeader className='post-metrics-header'>
                                            <ModalTitle
                                                className='post-metrics'
                                                id='post-metrics'>
                                                Post Metrics
                                            </ModalTitle>
                                            <Button
                                                color='primary'
                                                isOutline
                                                onClick={() =>
                                                    setPostMetricsModal(
                                                        !postMetricsModal,
                                                    )
                                                }>
                                                Close
                                            </Button>
                                        </ModalHeader>
                                        <ModalBody className='post-metrics-body'>
                                            <h5>
                                                Engagement, Impressions and
                                                Reach
                                            </h5>
                                            <p>
                                                View the engagement, reach, and
                                                impressions on your post in a
                                                simple and meaningful way.
                                            </p>
                                            <div className='mt-4'>
                                                <AnalyticsCount />
                                            </div>
                                        </ModalBody>
                                    </Modal>
                                </div>
                            </CardFooter>
                        </Card>
                    </div>
                </div>
            </Page>
        </PageWrapper>
    );
};

export default PostHistory;
